import {Injectable} from "@angular/core";

@Injectable()
export class OptionsConsultants {
    status = [{id:true,itemName:'Ativo'},
              {id:false,itemName:'Inativo'}]

    statusClient = [{id:true,itemName:'Cliente Ativo'},
              {id:false,itemName:'Cliente Inativo'}]

    division = [
        {id: 1, itemName: "Nação Digital"}
    ];

    model = [
        {id:1, itemName: "PJ"},
        {id:2, itemName: "CLT"},
        {id:3, itemName: "Estagiário"},
        {id:4, itemName: "Outros"}]

    honorarium = [
        {id:1, itemName: "Hora Aberta"},
        {id:2, itemName: "Hora Fechada"}];

    additivePending = [
        {id:false,itemName:'Todos'},
        {id:true,itemName:'Aditivo pendente'}
    ];
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/consultants/OptionsConsultant.ts